import React from 'react'

import { Box, SearchField, Table } from '@factorialco/deprecated-design-system'
import {
  InstalledSoftwareListEmployeeSoftwareMembershipFragment,
  SoftwareCardSoftwareSetupFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import NoSoftwareFound from 'modules/it_management/components/softwareByEmployee/SoftwareList/NoSoftwareFound'

import type { IllustrationType } from './PageInfo'
import PageInfo from './PageInfo'

interface SoftwareListProps {
  icon: IllustrationType
  title: string
  subtitle: string
  bottomLineText?: React.ReactNode
  paginatedItems:
    | InstalledSoftwareListEmployeeSoftwareMembershipFragment[]
    | SoftwareCardSoftwareSetupFragment[]
  onSearch?: (event: React.ChangeEvent<HTMLInputElement>) => void
  search?: string
  page: number
  loadMore: (page: number) => void
  hasMore: boolean
  children: React.ReactNode
}

interface SoftwareListContentProps {
  paginatedItems:
    | InstalledSoftwareListEmployeeSoftwareMembershipFragment[]
    | SoftwareCardSoftwareSetupFragment[]
  onSearch?: (event: React.ChangeEvent<HTMLInputElement>) => void
  search?: string
  page: number
  loadMore: (page: number) => void
  hasMore: boolean
  children: React.ReactNode
}

const SoftwareListContent = ({
  paginatedItems,
  onSearch,
  search,
  page,
  loadMore,
  hasMore,
  children,
}: SoftwareListContentProps) => {
  if (paginatedItems.length > 0) {
    return (
      <Box gap="s12">
        {onSearch && search && (
          <Box
            padding="s24"
            background="grey200"
            borderRadius={{
              all: 'abs008',
            }}
          >
            <SearchField
              variant="big"
              onSearch={onSearch}
              search={search}
              placeholder={i18n.t('common.search')}
            />
          </Box>
        )}
        <Box>
          <Table fullWidth hideBorder noRadius>
            <Table.BodyWithInfiniteScroll
              page={page}
              loadMore={loadMore}
              hasMore={hasMore}
              colSpan={1}
            >
              {children}
            </Table.BodyWithInfiniteScroll>
          </Table>
        </Box>
      </Box>
    )
  }
  return (
    <>
      {onSearch && search && (
        <SearchField
          variant="big"
          onSearch={onSearch}
          search={search}
          placeholder={i18n.t('common.search')}
        />
      )}
      <NoSoftwareFound />
    </>
  )
}

const SoftwareList = ({
  icon,
  title,
  subtitle,
  bottomLineText,
  paginatedItems,
  onSearch,
  search,
  page,
  loadMore,
  hasMore,
  children,
}: SoftwareListProps) => {
  return (
    <Box flexDirection="row" gap="s96">
      <Box width="fit-content">
        <PageInfo header={title} subheader={subtitle} icon={icon} bottomlineText={bottomLineText} />
      </Box>
      <Box width="full">
        <SoftwareListContent
          paginatedItems={paginatedItems}
          onSearch={onSearch}
          search={search}
          page={page}
          loadMore={loadMore}
          hasMore={hasMore}
        >
          {children}
        </SoftwareListContent>
      </Box>
    </Box>
  )
}

export default SoftwareList
